import { Box, Skeleton, Spacer } from '@bcp-nextgen-dx-component-factory/design-system';
import { AppLayout } from '@components';
import { UIHelper } from '@helpers';
import { useResponsive } from '@hooks';
import { CUSTOM_BREAKPOINT } from '@types';

interface LoginSkeletonProps {
	onCloseClick?: () => void;
}

export const LoginSkeletonDesktop = ({ onCloseClick }: LoginSkeletonProps) => {
	const { windowWidth } = useResponsive();

	return (
		<AppLayout styles={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
			<BannerSkeletonDesktop />

			<Box
				styles={{
					flexDirection: 'column',
					position: 'relative',
					height: '100vh',
				}}
			>
				<Box
					styles={{
						overflowY: 'auto',
						flex: 1,
						alignItems: 'start',
					}}
				>
					<Box
						styles={{
							overflowY: 'auto',
							flex: 1,
							flexDirection: 'column',
							width: '100%',
							padding: windowWidth > CUSTOM_BREAKPOINT ? UIHelper.rem(120) : UIHelper.rem(120, 24),
							maxWidth: windowWidth > CUSTOM_BREAKPOINT ? UIHelper.rem(700) : UIHelper.rem(508),
						}}
					>
						<FormSkeletonDesktop />
					</Box>
				</Box>
			</Box>
		</AppLayout>
	);
};

const BannerSkeletonDesktop = () => {
	return (
		<Box
			styles={{
				background: 'linear-gradient(135deg, #d1005d -0.21%, #e3669e 99.79%)',
				flexDirection: 'column',
				padding: UIHelper.rem(120, 96, 136),
				alignItems: 'end',
			}}
		>
			<Box
				styles={{
					flex: 1,
					flexDirection: 'column',
					width: '100%',
					maxWidth: UIHelper.rem(462),
				}}
			>
				<Spacer vertical={UIHelper.rem(51)} />

				<Box styles={{ marginTop: UIHelper.rem(64) }}>
					<Skeleton height={UIHelper.rem(104)} borderRadius={10} variant="dark" />
				</Box>

				<Box styles={{ flexDirection: 'column', marginTop: UIHelper.rem(200) }}>
					<Skeleton height={UIHelper.rem(21)} borderRadius={10} variant="dark" />
					<Spacer vertical={UIHelper.rem(8)} />
					<Skeleton height={UIHelper.rem(84)} borderRadius={10} variant="dark" />
				</Box>

				<Box
					styles={{
						marginTop: 'auto',
						marginBottom: UIHelper.rem(48),
						alignSelf: 'start',
						cursor: 'pointer',
					}}
				></Box>
			</Box>
		</Box>
	);
};

const FormSkeletonDesktop = () => (
	<>
		<Skeleton height={UIHelper.rem(32)} borderRadius={10} />
		<Spacer vertical={UIHelper.rem(32)} />
		<Skeleton height={UIHelper.rem(64)} borderRadius={10} />
		<Spacer vertical={UIHelper.rem(32)} />
		<Skeleton height={UIHelper.rem(48)} width={UIHelper.rem(170)} borderRadius={10} />
	</>
);
